import { Box, Image, Theme, Typography } from "@outschool/backpack";
import { faBullseyeArrow } from "@outschool/icons";
import { useMachineTranslation, useTranslation } from "@outschool/localization";
import { Screen } from "@outschool/ui-utils";
import React from "react";

import LearningGrowthImage from "../../../../images/learner_growth.png";
import { YellowBlobIcon } from "../subcomponents/IconWithBackground";
import ShowMoreModal from "../subcomponents/ShowMoreModal";

function LearningGoals({
  learningGoals,
  headerRef,
  showExpanded
}: {
  learningGoals: string[];
  headerRef?: React.RefObject<HTMLElement>;
  showExpanded?: boolean;
}) {
  const { translate } = useMachineTranslation();
  const isMobile = Screen.useIsMobile();
  const { t } = useTranslation(
    "client\\components\\detailPage\\sections\\LearningGoals"
  );

  const renderLearningGoals = (learningGoals: string[]) => {
    return (
      <Box sx={{ marginBottom: 16 }}>
        {learningGoals.map((goal, index) => (
          <Box key={index} sx={{ display: "flex", marginBottom: 8, gap: 8 }}>
            <YellowBlobIcon
              icon={faBullseyeArrow}
              iconSx={{ width: 16, height: 16 }}
            />
            <Box component={"pre"} sx={{ paddingLeft: 8, margin: 0 }}>
              <Typography variant="body1">{translate(goal.trim())}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    );
  };

  if (learningGoals.length === 0) {
    return null;
  }

  return (
    <Box
      ref={headerRef}
      sx={(_theme: Theme) => ({
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        borderRadius: 16,
        padding: 20,
        backgroundColor: "warning.50"
      })}
    >
      <Box>
        <Typography
          variant="h4"
          id="learning-overview"
          sx={{ marginBottom: 16 }}
          emphasized
        >
          {t("Learning Goals")}
        </Typography>
        {renderLearningGoals(
          showExpanded ? learningGoals : learningGoals.slice(0, 2)
        )}
        {learningGoals?.length > 2 && !showExpanded && (
          <ShowMoreModal
            buttonLabel={t("Show all {{count}} learning goals", {
              count: learningGoals.length
            })}
            trackingName={"learning_goals"}
          >
            <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: 16 }}>
              {t("Learning Goals")}
            </Typography>
            {renderLearningGoals(learningGoals)}
          </ShowMoreModal>
        )}
      </Box>

      {isMobile ? null : (
        <Box sx={{ alignSelf: "flex-end", marginLeft: "auto" }}>
          <Image
            src={
              typeof LearningGrowthImage === "string"
                ? LearningGrowthImage
                : LearningGrowthImage.src
            }
            width={100}
            height={100}
            alt={t("learning goal")}
          />
        </Box>
      )}
    </Box>
  );
}
export default React.memo(LearningGoals);
